import { jsx as _jsx } from "react/jsx-runtime";
import { helpId } from '@rjsf/utils';
/** The `FieldHelpTemplate` component renders any help desired for a field
 *
 * @param props - The `FieldHelpProps` to be rendered
 */
export default function FieldHelpTemplate(props) {
    const { idSchema, help } = props;
    if (!help) {
        return null;
    }
    const id = helpId(idSchema);
    if (typeof help === 'string') {
        return (_jsx("p", Object.assign({ id: id, className: 'help-block' }, { children: help })));
    }
    return (_jsx("div", Object.assign({ id: id, className: 'help-block' }, { children: help })));
}
//# sourceMappingURL=FieldHelpTemplate.js.map